module.exports = __webpack_public_path__ + "static/img/087E072F-AF7F-4A14-ACC1-D1A3BCA6F32E.e3310e54.png";